import {RefObject, useEffect, useRef} from 'react';

import {SourcingTableDispatch} from '../../../store/sourcingTable/reducer';

const SCROLL_THRESHOLD_PX = 560;

export function useInfiniteScroll(
  scrollContainerRef: RefObject<HTMLDivElement | null>,
  dispatch: SourcingTableDispatch,
  isFetching: boolean,
  isEnabled: boolean,
  nextPage: number
) {
  const nextPageRef = useRef(nextPage);

  useEffect(() => {
    nextPageRef.current = nextPage;
  }, [nextPage]);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (!scrollContainer || !isEnabled) {
      return;
    }

    function handleScroll() {
      const container = scrollContainerRef.current;
      if (!container || isFetching || !isEnabled) {
        return;
      }

      const scrollTop = container.scrollTop;
      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

      if (distanceFromBottom < SCROLL_THRESHOLD_PX) {
        dispatch({type: 'changePage', page: nextPageRef.current});
      }
    }

    scrollContainer.addEventListener('scroll', handleScroll, {passive: true});
    handleScroll();

    return () => {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [scrollContainerRef, dispatch, isFetching, isEnabled]);
}
